import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { Routes } from '../../navigation/config/routes'
import { NVLHomePage } from './NVLHomePage'
import { NVLListPage } from './NVLListPage'

export const NVLRoot = () => {
    return (
        <Switch>
            <Route
                exact
                path={Routes.public.nvl.root}
                component={NVLHomePage}
            />
            <Route path={Routes.public.nvl.list} component={NVLListPage} />
            <Redirect to={Routes.public.nvl.root} />
        </Switch>
    )
}
